import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FormsModule } from '@angular/forms';
import { LinkToTypesService } from '@fi-shared/link-to/link-to-types.service';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';

@NgModule({
    imports: [CommonModule, FormsModule, FiAppTextSharedModule, SelectSearchModule],
    declarations: [],
    providers: [LinkToTypesService],
    exports: [],
})
export class LinkToModule {}
